import { render, staticRenderFns } from "./BulkShipmentSenderAddressEditor.vue?vue&type=template&id=452e6bce"
import script from "./BulkShipmentSenderAddressEditor.vue?vue&type=script&lang=js"
export * from "./BulkShipmentSenderAddressEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports